export const getCollectionLanguages = ({languages}) => {

    return languages.map(language => {
        return language.value
    })

}

export default getCollectionLanguages